<template>
  <DocumentsBrowserWireframe>
    <template #topbar-left>
      <BackButton :go-back="goBack" />
    </template>

    <template #details-left>
      <MediaDetails />
    </template>

    <template #search>
      <MediaSearchAndFilters />
    </template>

    <template #assets>
      <MediaList />
    </template>
  </DocumentsBrowserWireframe>
</template>

<script>
import { defineComponent, ref } from 'vue';
import { useWesley } from '@anthill-modules/wesley-components';

import useModals from '~/composables/useModals';
import useFormFilters from '~/composables/useFormFilters';

import MediaDetails from '~/components/conversation/mediaPanel/MediaDetails.vue';
import DocumentsBrowserWireframe from '~/components/common/DocumentsBrowserWireframe.vue';
import BackButton from '~/components/common/BackButton.vue';
import MediaSearchAndFilters from '~/components/conversation/mediaPanel/MediaSearchAndFilters.vue';
import MediaList from '~/components/conversation/mediaPanel/MediaList.vue';

export default defineComponent({
  components: { MediaSearchAndFilters, BackButton, MediaDetails, DocumentsBrowserWireframe, MediaList },
  setup() {
    const { setMediaPanelOpened } = useModals();
    const { setSearchQuery } = useFormFilters();
    const { sendMessage: sendMessageToDocument } = useWesley();

    const mediaAssets = ref([]);

    const goBack = () => {
      setMediaPanelOpened({ cssPath: '', opened: false });
      setSearchQuery('');
      sendMessageToDocument({ method: 'deselectElement' });
    };

    return {
      goBack,
      mediaAssets,
    };
  },
});
</script>

<style scoped lang="scss">
.dialog-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}
</style>
